import React, { useEffect, useState } from "react";
import { fetchBuildings, upsertBuilding } from "../../services/Administracion/buildingsService";
import { Building } from "../../types/building";

import { useAuth } from "../../context/AuthContext";
import BuildingModal from "./BuildingModal";




const BuildingList: React.FC = () => {
    const { user } = useAuth();
    const [buildings, setBuildings] = useState<Building[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedBuilding, setSelectedBuilding] = useState<Building>({ building_id: 0, building_name: '', description: '', is_active: true, created_by: '', date_created: '' });
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        loadBuildings();
    }, []);

    const loadBuildings = async () => {
        setLoading(true);
        try {
            const data = await fetchBuildings();
            const processedBuildings = data.map((building: Building) => ({
                ...building,
            }));
            setBuildings(processedBuildings);
        } catch (error: any) {
            setError(error.message || "Error cargando Edificios");
        } finally {
            setLoading(false);
        }
    };
    const handleCreateBuilding = (building?: Building) => {
        console.log('Building a editar: ', building);
        setSelectedBuilding(building || { building_id: 0, building_name: '', description: '', is_active: true, created_by: user?.User.email || '', date_created: '' });
        setShowModal(true);
    }

    const handleChangeStatusBuilding = async (building: Building) => {
        if (!building.building_id) return;
        if (!window.confirm(`¿Está seguro de desactivar el edificio: ${building.building_name}?`)) return;
        building.is_active = !building.is_active;
        try {
            await upsertBuilding(building);
            loadBuildings();
        } catch (error: any) {
            setError(error.message || "Error al desactivar el edificio"); //error.message es el mensaje que viene del servidor
        }
    };

    const handleSaveBuilding = async (building: Building) => {
        setLoading(true);
        try {
            if(building.building_id){
                building.updated_by = user?.User.email || '';
            } else {
                building.created_by = user?.User.email || '';
            }
            await upsertBuilding(building);
            loadBuildings();
        } catch (error: any) {
            setError(error.message || "Error guardando eñ edificio");
        } finally {
            setLoading(false);
            setShowModal(false);
        }
    };



    if (loading) {
        return <div>Cargando Edificios...</div>;
    }
    if (error) {
        return <div>Error: {error}</div>;
    }


    return (
        <div className="container mt-4">
            <h4 className="mb-4">Mantenimiento de Edificios</h4>
            <div className="mb-3 text-end">
                <button className="btn btn-primary" onClick={() => handleCreateBuilding()}>
                    Crear Edificio
                </button>
            </div>
            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        <th>Activo</th>
                        <th>Fecha Creación</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {buildings.map((building) => (
                        <tr key={building.building_id}>
                            <td>{building.building_id}</td>
                            <td>{building.building_name}</td>
                            <td>{building.description}</td>
                            <td>{building.is_active ? 'Si' : 'No'}</td>
                            <td>{new Date(building.date_created).toLocaleDateString()}</td>
                            <td>
                                <button className="btn btn-sm btn-secondary me-2" onClick={() => handleCreateBuilding(building)}>Editar</button>
                                <button
                                    className={`btn btn-sm ${building.is_active ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => handleChangeStatusBuilding(building)}
                                >
                                    {building.is_active ? 'Desactivar' : 'Activar'}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showModal && selectedBuilding && (
                <BuildingModal
                    building={selectedBuilding}
                    onClose={() => setShowModal(false)}
                    onSave={handleSaveBuilding}
                />
            )}
        </div>
    );
}

export default BuildingList;